import React from 'react';
import classNames from 'classnames/bind';
import { withAutoMetric } from '@beef/auto-metric';
import { compose } from '@beef/redux';
import { enhancedConnect } from "../../../utils";
import { CarouselCommonProvider } from "../context";
import { CarouselPagination } from "../CarouselPagination";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _CarouselContainer = function _CarouselContainer(_ref) {
  var children = _ref.children,
    loop = _ref.loop,
    _ref$showPagination = _ref.showPagination,
    showPagination = _ref$showPagination === void 0 ? true : _ref$showPagination,
    anchorId = _ref.anchorId,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('component', className),
    id: anchorId,
    "data-t-id": "Carousel-CarouselContainer"
  }, /*#__PURE__*/React.createElement(CarouselCommonProvider, {
    loop: loop
  }, children, showPagination && /*#__PURE__*/React.createElement(CarouselPagination, null)));
};
export var CarouselContainer = compose(enhancedConnect(), withAutoMetric.Section(function (props) {
  return {
    id: props.anchorId,
    name: 'Carousel'
  };
}))(_CarouselContainer);